
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"creditConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capping"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capping"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"types"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"types"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditConfigTypeGeneric"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credits"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditConfigTypeActivityV1"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roundCredits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditsDecimals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientFactor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditsPerStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activityConversions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditsPerKm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kcalPerHour"},"arguments":[],"directives":[]}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditConfigTypeActivityV2"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roundCredits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditsDecimals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditsPerKcal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditsPerStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manualCreditsPerKcal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manualCreditsPerStep"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditConfigTypeActivityV3"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creditsPerKcal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hoursPerStep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kcalPerHourForSteps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kcalPerHour"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kcalPerHour"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionPeriod"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"spentCreditsLimit"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countForLastXDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countInCollectionPeriod"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1042}};
    doc.loc.source = {"body":"fragment creditConfig on CreditConfig {\n    capping {\n      capping\n      types\n    }\n    types {\n      version\n      type\n      enabled\n      ...on CreditConfigTypeGeneric {\n          credits\n      }\n      ...on CreditConfigTypeActivityV1 {\n          roundCredits\n          creditsDecimals\n          clientFactor\n          creditsPerStep\n          activityConversions {\n              activity\n              creditsPerKm\n              kcalPerHour\n          }\n      }\n      ...on CreditConfigTypeActivityV2 {\n          roundCredits\n          creditsDecimals \n          creditsPerKcal\n          creditsPerStep\n          manualCreditsPerKcal\n          manualCreditsPerStep\n      }\n      ...on CreditConfigTypeActivityV3 {\n          creditsPerKcal\n          hoursPerStep\n          kcalPerHourForSteps\n          kcalPerHour {\n              activity\n              kcalPerHour\n          }\n      }\n    }\n    collectionPeriod {\n      from\n      to\n    }\n    spentCreditsLimit {\n      value\n      countForLastXDays\n      countInCollectionPeriod\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["creditConfig"] = oneQuery(doc, "creditConfig");
        
